export const userCommon = {
  en: {
    "user.common.error#1": "Could not create a random slug. Try again later.",
  },
  es: {
    "user.common.error#1": "No se pudo crear un slug aleatorio. Vuelva a intentarlo más tarde.",
  },
};
